import {
  GET_CONFIGURATION_EXITO,
  GET_CONFIGURATION
} from '../types/configurationsActionsTypes'
import { ConfigurationSaga } from '../../interfaces/Configuration/Configuration'

export type ConfigurationAction =
  | ConfigurationsActions
  | ConfigurationsActionsAsync

// Esto va a REDUX
export interface ConfigurationsActions {
  type: typeof GET_CONFIGURATION_EXITO
  configuration: ConfigurationSaga[]
  error: string | undefined
}

export const getConfigurationAction = (
  configuration: ConfigurationSaga[],
  error?: string
): ConfigurationsActions => {
  return {
    type: GET_CONFIGURATION_EXITO,
    configuration: configuration,
    error
  }
}

// Esto va a SAGA
export interface ConfigurationsActionsAsync {
  type: typeof GET_CONFIGURATION
}

export const getConfigurationActionAsync = (): ConfigurationsActionsAsync => {
  return {
    type: GET_CONFIGURATION
  }
}
